// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../components/Table";
// Engine
import { axiosAPI } from "../../../engine/config/axios";

const VacationBalanceTable:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;
  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  const gridParams = {
    grids: [{ name: 'absencesBalance', hashCache }],
  }

  return <Table
    api={axiosAPI.vacation.balance.table}
    apiParams={apiParams}
    gridName="absencesBalance"
    gridParams={gridParams}
    sortingMode="multiple"
  />;
}

function VacationBalanceTablePortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<VacationBalanceTable hashCache={Root?.dataset.hashCache} />, Root) : null;
}

export default VacationBalanceTablePortal;
